import React from 'react';
import { Treemap, ResponsiveContainer, Tooltip } from 'recharts';

const typeColors = {
  Consultation: '#1d4ed8', // bg-blue-700
  Exam: '#3b82f6',         // bg-blue-500
  Procedure: '#60a5fa',    // bg-blue-400
  Vaccine: '#bfdbfe',      // bg-blue-200
  Informal: '#dbeafe',     // bg-blue-100
  Urgency: '#f87171',      // bg-red-400
};

const ChartTopics = ({ data }) => {
  return (
    <div className="h-64 bg-white shadow-lg rounded-xl p-3">
      <span className="text-md font-semibold block mb-2">Topics distribution</span>
      <ResponsiveContainer width="100%" height="85%">
        <Treemap
          width={400}
          height={200}
          data={data}
          dataKey="size"
          nameKey="name"
          stroke="#fff"
          isAnimationActive={false}
          content={({ x, y, width, height, name, index }) => {
            const fontSize = width < 70 || height < 30 ? 10 : 12;
            const fillColor = typeColors[name] || '#3b82f6'; // fallback para azul padrão
            return (
              <g key={index}>
                <rect
                  x={x}
                  y={y}
                  width={width}
                  height={height}
                  fill={fillColor}
                  stroke="#fff"
                  strokeWidth={1}
                  rx={4}
                />
                <text
                  x={x + width / 2}
                  y={y + height / 2}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize={fontSize}
                  fill="#fff"
                  fontWeight="normal"
                  style={{
                    paintOrder: 'stroke',
                    stroke: 'rgba(0, 0, 0, 0.3)',
                    strokeWidth: 1,
                  }}
                >
                  {name}
                </text>
              </g>
            );
          }}
        >
          <Tooltip />
        </Treemap>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartTopics;
